import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a851204"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main h-100 w-100" }
const _hoisted_2 = { class: "container h-100" }
const _hoisted_3 = { class: "row h-100" }
const _hoisted_4 = { class: "col-sm-12 col-md-12 col-lg-10 mx-auto d-table h-100" }
const _hoisted_5 = { class: "d-table-cell align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.background))),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ])
      ])
    ])
  ]))
}